import { ComponentProps } from "react";
import { BlockTitle } from "@blocks/Blocks";
import Card from "@particles/card/Card";
import { CardVariations } from "@particles/card/utils/types";
import { cn } from "@util/helpers";

type RelatedVideosProps = {
  /** This is the classname of the component. */
  className?: string;
  /** This is the list of videos to be displayed. */
  videos: ComponentProps<typeof Card>[];
};

/** This is the component for displaying related videos. */
const RelatedVideos = ({
  className,
  videos,
}: RelatedVideosProps): React.ReactElement => {
  const variant: CardVariations = {
    image: {
      isVideo: true,
      position: "",
      width: "w-full",
      aspectRatio: "aspect-ratio-16/9",
    },
    content: {
      width: "w-full pl-4 lg:pl-0 lg:pt-4",
    },
    title: {
      color: "text-gray-850",
      size: "text-base",
      extraClass: "font-lct",
    },
  };

  return (
    <div data-testid="related-videos-component">
      <BlockTitle text="RELATED VIDEOS" rootClassName="mb-3" />

      <div className={cn("flex flex-wrap gap-6 lg:flex-nowrap", className)}>
        {videos.map((cardsProps) => {
          return (
            <Card
              key={cardsProps.id}
              variations={variant}
              {...cardsProps}
              className="block lg:w-3/12"
            />
          );
        })}
      </div>
    </div>
  );
};

export default RelatedVideos;
